import React from 'react';
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
} from '@mui/material';
import ExpandMoreIcon from '@mui/icons-material/ExpandMore';
import { makeStyles } from '@mui/styles';
import { cpStyle } from '../index.styles';
import { IResultChildren, childType } from './types';
import { LOGINS_ACCOUNTS, loginsAccountsPrefixEnum } from '../constants';

interface IChildrenProps {
  childInfo: IResultChildren;
}

export const ChildrenComponent: React.FC<IChildrenProps> = (props): JSX.Element => {
  const useStyles = makeStyles(cpStyle);
  const classes = useStyles();

  const { childInfo } = props;
  const childFields = childInfo.fields.sort((a, b) => a.order - b.order);

  const getGroupedData = (data: any, prefix: string) => {
    const groupedData = data
      .map((entry: any) => {
        const filteredData: any = {};
        for (const [key, value] of Object.entries(entry)) {
          if (key.startsWith(`${prefix}`)) {
            filteredData[key] = value;
          }
        }
        return Object.keys(filteredData).length > 0 ? filteredData : null;
      })
      .filter(Boolean);
    return groupedData;
  };

  if (childInfo.title === LOGINS_ACCOUNTS) {
    const siteData = getGroupedData(childInfo.fields, loginsAccountsPrefixEnum.SITE);
    const foundationsData = getGroupedData(childInfo.fields, loginsAccountsPrefixEnum.FOUNDATIONS);
    const supplyOrderData = getGroupedData(childInfo.fields, loginsAccountsPrefixEnum.SUPPLY_ORDER);
    return (
      <Grid item xs={12}>
        <Accordion
          sx={{
            backgroundColor: 'transparent',
          }}
        >
          <AccordionSummary
            expandIcon={<ExpandMoreIcon className={classes.expandIconColor} />}
            aria-controls="panel1a-content"
            id="panel1a-header"
          >
            <Typography>
              <Tooltip title={childInfo.title} placement="right-end">
                <span className={classes.accordionTitle}>{`${childInfo.title}`}</span>
              </Tooltip>
            </Typography>
          </AccordionSummary>
          <AccordionDetails className={classes.AccordionDetails}>
            {siteData.length > 0 && (
              <Grid container className={classes.AccordionDetailsContainer}>
                <Grid item xs={4}>
                  <Typography className={classes.subTitleInfo}>Site</Typography>
                </Grid>
              </Grid>
            )}
            {(siteData || []).map((entry: any, index: any) => {
              const usernameKey = Object.keys(entry).find(k => k.includes('username')) ?? '';
              const passwordKey = Object.keys(entry).find(k => k.includes('password')) ?? '';

              return (
                <Grid container className={classes.AccordionDetailsContainer}>
                  <Grid item xs={4}>
                    <Typography variant="body1">
                      <strong>Username:</strong> {entry[usernameKey]}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant="body1">
                      <strong>Password:</strong> {entry[passwordKey]}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
            {foundationsData.length > 0 && (
              <Grid container className={classes.AccordionDetailsContainer}>
                <Grid item xs={4}>
                  <Typography className={classes.subTitleInfo}>Foundations</Typography>
                </Grid>
              </Grid>
            )}
            {(foundationsData || []).map((entry: any, index: any) => {
              const usernameKey = Object.keys(entry).find(k => k.includes('username')) ?? '';
              const passwordKey = Object.keys(entry).find(k => k.includes('password')) ?? '';

              return (
                <Grid container className={classes.AccordionDetailsContainer}>
                  <Grid item xs={4}>
                    <Typography variant="body1">
                      <strong>Username:</strong> {entry[usernameKey]}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant="body1">
                      <strong>Password:</strong> {entry[passwordKey]}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
            {supplyOrderData.length > 0 && (
              <Grid container className={classes.AccordionDetailsContainer}>
                <Grid item xs={4}>
                  <Typography className={classes.subTitleInfo}>Supply Order</Typography>
                </Grid>
              </Grid>
            )}
            {(supplyOrderData || []).map((entry: any, index: any) => {
              const usernameKey = Object.keys(entry).find(k => k.includes('username')) ?? '';
              const passwordKey = Object.keys(entry).find(k => k.includes('password')) ?? '';

              return (
                <Grid container className={classes.AccordionDetailsContainer}>
                  <Grid item xs={4}>
                    <Typography variant="body1">
                      <strong>Username:</strong> {entry[usernameKey]}
                    </Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography variant="body1">
                      <strong>Password:</strong> {entry[passwordKey]}
                    </Typography>
                  </Grid>
                </Grid>
              );
            })}
          </AccordionDetails>
        </Accordion>
      </Grid>
    );
  }

  return (
    <Grid item xs={12}>
      <Accordion
        sx={{
          backgroundColor: 'transparent',
        }}
      >
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className={classes.expandIconColor} />}
          aria-controls="panel1a-content"
          id="panel1a-header"
        >
          <Typography>
            <Tooltip title={childInfo.title} placement="right-end">
              <span className={classes.accordionTitle}>{`${childInfo.title}`}</span>
            </Tooltip>
          </Typography>
        </AccordionSummary>
        <AccordionDetails className={classes.AccordionDetails}>
          {childFields
            .filter(t => t.view)
            .map((f, i) => {
              if (f.type === childType.SubTitle) {
                return (
                  <Grid container key={`${i}`} className={classes.AccordionDetailsContainer}>
                    <Grid item xs={4}>
                      <Typography className={classes.subTitleInfo}>{`${f.title}`}</Typography>
                    </Grid>
                  </Grid>
                );
              }

              return (
                <Grid container key={`${i}`} className={classes.AccordionDetailsContainer}>
                  <Grid item xs={4}>
                    <Typography>{`${f.title}`}</Typography>
                  </Grid>
                  <Grid item xs={8}>
                    <Typography className={classes.valueInfo}>{`${f.value}`}</Typography>
                  </Grid>
                </Grid>
              );
            })}
        </AccordionDetails>
      </Accordion>
    </Grid>
  );
};
